;(function () {

  'use strict';

  const fontSelectors = document.querySelectorAll('[data-font-selector]');
  const closeButtons = document.querySelectorAll('[data-close]');
  // const selectors = document.querySelectorAll('[data-font-selector-font]');
  //
  const licenceControls = document.querySelector('[data-licences]');
  // let selectedLicenceOptions = {};
  // let selectedVariantNames = [];

  /******************************************
   * Typeface intro and initials
   *
   ******************************************/
  const intro = document.querySelector('[data-intro]');
  const initials = document.querySelector('[data-initials]');

  document.addEventListener('a2.initials.drawn', function(ev) {
    let introHeight = intro.scrollHeight;
    let initialsHeight = initials.clientHeight;
    // if (initials.classList.contains('leading-trim')) {
    //   let fontSize = parseInt(initials.getAttribute('value'));
    //   initialsHeight = initialsHeight - (fontSize * ((0.3 + 0.25) * 0.5));
    // }
    if (introHeight - initialsHeight > 0) {
      initials.style.marginBottom = ((introHeight - initialsHeight) * 0.9).toString(10) + 'px';
    }
  });

  /******************************************
   * Add to Cart buttons
   *
   ******************************************/
  const snakeCase = string => {
    return string.replace(/\W+/g, " ")
        .split(/ |\B(?=[A-Z])/)
        .map(word => word.toLowerCase())
        .join('_');
  };

  document.addEventListener('change', function(ev) {
    if (ev.target.matches('[data-type-tester-control-font]')) {
      let parentDiv = ev.target.closest('[data-font]');
      let addToCartButton = parentDiv.querySelector('button[data-add-to-cart]');
      let fontParts = ev.target.querySelector('option[value="' + ev.target.value + '"]').dataset.font.split('-');
      let fontName = '';
      fontParts.forEach((part, index) => {
        fontName += snakeCase(part);
        if (index < (fontParts.length - 1)) {
          fontName += '-';
        }
      });
      addToCartButton.dataset.addToCart = fontName;
    }
  });

  document.addEventListener('click', function(ev) {
    if (ev.target.matches('button[data-add-to-cart]')) {
      let fontToAdd = ev.target.dataset.addToCart;
      let fontCheckbox = document.querySelector('#' + fontToAdd);
      if (fontCheckbox) {
        fontCheckbox.checked = true;
      }
    }
  });

  /******************************************
   * Font licence other enquiry - Buy fonts
   *
   ******************************************/
  let otherForm = document.querySelector('[data-other-licence-form]');
  let otherResponse = document.querySelector('[data-other-licence-response]');

  if (otherForm && otherResponse) {
    otherForm.addEventListener('submit', function(ev) {
      ev.preventDefault();
      ev.stopPropagation();

      let data = {};
      data.CRAFT_CSRF_TOKEN = otherForm.querySelector('[name="CRAFT_CSRF_TOKEN"]').value;
      data.typefaceId = otherForm.querySelector('[name="typefaceId"]').value;
      data.other = [];

      let otherLicences = otherForm.querySelectorAll('[name="other[]"]');

      Array.prototype.forEach.call(otherLicences, function(each) {
        if (each.checked) {
          data.other.push(each.value);
        }
      });

      data.name = otherForm.querySelector('[name="name"]').value;
      data.email = otherForm.querySelector('[name="email"]').value;
      data.details = otherForm.querySelector('[name="details"]').value;
      data.snaptcha = otherForm.querySelector('[name="snaptcha"]').value;

      let url = '/actions/' + otherForm.querySelector('[name="action"]').value;

      fetch(url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      })
          .then((response) => response.json())
          .then(function(result) {
            if (result.message) {
              otherResponse.innerText = result.message;
              otherResponse.classList.remove('hidden');
              otherForm.closest('form').querySelector('button[type="submit"]').classList.add('hidden');
            }
          })
          .catch(function (error) {
            otherResponse.innerText = 'Sorry, your message failed to send, please email us at info@a2-type.co.uk with your request.';
            otherResponse.classList.remove('hidden');
            console.log(error);
            console.log(error.status); // xhr.status
            console.log(error.statusText); // xhr.statusText
            return false;
          });
    });
  }

  /******************************************
   * Font selector checkboxes - Buy fonts
   *
   ******************************************/
  // const resetSelections = document.querySelector('#resetSelections');
  // if (resetSelections) {
  //   document.addEventListener('a2.resetSelections', function(ev) {
  //     console.log('Event triggered');
  //   });
  // }
  // if (fontSelectors.length && licenceControls) {
    //   Array.prototype.forEach.call(closeButtons, function(btn) {
    //     btn.addEventListener('click', function(ev) {
    //       console.log('clicked');
    //       let licenceCheckboxes = licenceControls.querySelectorAll('input[type="checkbox"]');
    //       Array.prototype.forEach.call(licenceCheckboxes, function(checkbox) {
    //         console.log('setting checkbox');
    //         checkbox.checked = false;
    //       });
    //     });
    //   });
    // Array.prototype.forEach.call(fontSelectors, function(fontSelector) {
    //   const fontFamilySelector = fontSelector.querySelector('[data-font-selector-family]');
    //   const selectors = fontSelector.querySelectorAll('[data-font-selector-font]');
    //
    //   if (fontFamilySelector && selectors) {
    //     let changeEvent = new Event('change');
    //     fontFamilySelector.addEventListener('change', function(ev) {
    //       if (fontFamilySelector.checked) {
    //         Array.prototype.forEach.call(selectors, function(selector) {
    //           selector.checked = true;
    //           selector.dispatchEvent(changeEvent);
    //         });
    //       } else {
    //         Array.prototype.forEach.call(selectors, function(selector) {
    //           selector.checked = false;
    //           selector.dispatchEvent(changeEvent);
    //         });
    //       }
    //     });
    //   }
    // });
  // }


  /******************************************
   * Cart
   *
   ******************************************/
  // const cart = document.querySelector('[data-cart]');

  /******************************************
   * Font selector checkboxes - Buy fonts
   *
   ******************************************/
  // if (fontSelectors.length) {
  //   Array.prototype.forEach.call(fontSelectors, function(fontSelector) {
  //     const fontFamilySelector = fontSelector.querySelector('[data-font-selector-family]');
  //     const selectors = fontSelector.querySelectorAll('[data-font-selector-font]');
  //
  //     if (fontFamilySelector && selectors) {
  //       let changeEvent = new Event('change');
  //       fontFamilySelector.addEventListener('change', function(ev) {
  //         if (fontFamilySelector.checked) {
  //           Array.prototype.forEach.call(selectors, function(selector) {
  //             selector.checked = true;
  //             selector.dispatchEvent(changeEvent);
  //           });
  //         } else {
  //           Array.prototype.forEach.call(selectors, function(selector) {
  //             selector.checked = false;
  //             selector.dispatchEvent(changeEvent);
  //           });
  //         }
  //       });
  //     }
  //   });
  // }

  /******************************************
   * Font licence selectors - Buy fonts
   *
   ******************************************/
  // if (licenceControls && selectors.length) {
  //   const clearVariants = function(variantDiv) {
  //     let variantQtys = variantDiv.querySelectorAll('[data-qty]');
  //     if (variantQtys) {
  //       Array.prototype.forEach.call(variantQtys, function(qty) {
  //         qty.checked = false;
  //       });
  //     }
  //
  //     let variantOptions = variantDiv.querySelectorAll('[data-use]');
  //     if (variantOptions) {
  //       Array.prototype.forEach.call(variantOptions, function(use) {
  //         use.disabled = 'disabled';
  //       });
  //     }
  //
  //     let variantIds = variantDiv.querySelectorAll('[data-id]');
  //     if (variantIds) {
  //       Array.prototype.forEach.call(variantIds, function(id) {
  //         id.disabled = 'disabled';
  //       });
  //     }
  //   };
  //
  //   const updateVariants = function() {
  //     // Get all selected font variants
  //     let selectedVariants = document.querySelectorAll('[data-font-selector-font]:checked');
  //
  //     Array.prototype.forEach.call(selectedVariants, function(item) {
  //       selectedVariantNames.push(item.name);
  //     });
  //
  //     Array.prototype.forEach.call(selectedVariants, function(item) {
  //       let variantDiv = item.closest('div');
  //
  //       clearVariants(variantDiv);
  //
  //       Object.keys(selectedLicenceOptions).forEach(function(licence) {
  //         let variantQty = variantDiv.querySelector(`[data-qty="${licence}"]`);
  //         if (variantQty) {
  //           variantQty.checked = true;
  //         }
  //
  //         let variantOption = variantDiv.querySelector(`[data-use="${licence}"]`);
  //         if (variantOption) {
  //           variantOption.value = selectedLicenceOptions[licence];
  //           variantOption.disabled = '';
  //         }
  //
  //         let variantId = variantDiv.querySelector(`[data-id="${licence}"]`);
  //         if (variantId) {
  //           variantId.disabled = '';
  //         }
  //       });
  //     });
  //   };
  //
  //   licenceControls.addEventListener('change', function(ev) {
  //     let selectedLicences = licenceControls.querySelectorAll('[data-licence-checkbox]:checked');
  //     selectedLicenceOptions = {};
  //
  //     Array.prototype.forEach.call(selectedLicences, function(item) {
  //       selectedLicenceOptions[item.name] = item.previousElementSibling.value;
  //     });
  //
  //     updateVariants(selectedLicenceOptions);
  //   });
  //
  //   Array.prototype.forEach.call(selectors, function(item) {
  //     item.addEventListener('change', function(ev) {
  //       if (!item.checked) {
  //         // Clear selected variants if set
  //         let variantDiv = item.closest('div');
  //
  //         if (variantDiv) {
  //           clearVariants(variantDiv);
  //         }
  //
  //         // Clear family selector if set
  //         let familySelectorDiv = item.closest('[data-font-selector]');
  //
  //         if (familySelectorDiv) {
  //           let familySelector = familySelectorDiv.querySelector('[data-font-selector-family]');
  //
  //           if (familySelector && familySelector.checked) {
  //             familySelector.checked = false;
  //           }
  //         }
  //       }
  //
  //       updateVariants(selectedLicenceOptions);
  //     });
  //   });
  // }

})();
